import securityService from '../services/securityService';
import router from '../router';

export const authentication = {
    namespaced: true,
    state: {
        status: {},
        user: null,
        redirectLink: ""
    },
    actions: {
        async initialize({ commit }) {
            if (router.currentRoute.path === '/reset-password' ||
                router.currentRoute.path === '/request-reset-password' ||
                router.currentRoute.path === '/new-user-set-password') {
                return;
            }

            try {
                var user = await securityService.getLoggedInUser();
                commit('loginSuccess', user);
            }
            catch { /* let the interceptor handle any redirection to the login page. */ }
        },
        login({ dispatch, commit, state }, { emailAddress, password }) {
            commit('loginRequest', { emailAddress });

            var landingPage = state.redirectLink === "" ? '/' : state.redirectLink;
            commit('redirect', "");

            securityService
                .login(emailAddress, password)
                .then(
                    response => {
                        commit('loginSuccess', response.data);
                        router.push(landingPage);
                    }
                )
                .catch(
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        loginSuccess({ commit }, user) {
            commit('loginSuccess', user);
        },
        setPasswordSuccuss({ commit }, user) {
            commit('setPasswordSuccuss', user);
        },
        logout({ commit }) {
            commit('logout');
            securityService.logout();           
            if (router.currentRoute.path !== '/login') {
                router.push('/login');
            }
        },
        logoutForbidden({ commit }) {
            commit('logout');
            securityService.logout();
            if (router.currentRoute.path !== '/login') {
                commit('redirect', router.currentRoute.path);
                router.push('/login');
            }
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        setPasswordSuccuss(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        },
        redirect(state, link) {
            state.redirectLink = link;
        }
    }
}
